import React, { Component } from 'react';
import { MDBTable, MDBTableBody, MDBTableHead, MDBInput } from 'mdb-react-ui-kit';

export class EditableTable extends Component {

  constructor(props) {

    super(props);
    this.state = {
      data: this.parseCSV(this.props.versionTabla.csvTabla, this.props.versionTabla.separadorColumnas, this.props.versionTabla.separadorFilas),
      sortedColumn: null,
      sortDirection: 'asc',
    };
  }

  parseCSV = (csv, columnSeparator, rowSeparator) => {
    const rows = csv.split(rowSeparator);
    const headers = rows[0].split(columnSeparator);
    const data = rows.slice(1).map(row => {
      const values = row.split(columnSeparator);
      return headers.reduce((obj, header, index) => {
        obj[header] = values[index];
        return obj;
      }, {});
    });
    return { headers, data };
  };

  handleEdit = (rowIndex, column, value) => {
    const updatedData = [...this.state.data.data];
    updatedData[rowIndex][column] = value;
    this.setState({ data: { ...this.state.data, data: updatedData } }, () => {
      this.updateCSV();
    });
  };

  updateCSV = () => {
    const { headers, data } = this.state.data;
    const csvData = [headers.join(this.props.versionTabla.separadorColumnas)];
    data.forEach(row => {
      const rowData = headers.map(header => row[header]);
      csvData.push(rowData.join(this.props.versionTabla.separadorColumnas));
    });
    const updatedCSV = csvData.join(this.props.versionTabla.separadorFilas);
    //this.props.onCSVUpdate(updatedCSV);
  };

  sortData = (column) => {
    const { data, sortedColumn, sortDirection } = this.state;
    const newDirection = sortedColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    const sortedData = [...data.data].sort((a, b) => {
      if (a[column] < b[column]) return newDirection === 'asc' ? -1 : 1;
      if (a[column] > b[column]) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    this.setState({ data: { ...data, data: sortedData }, sortedColumn: column, sortDirection: newDirection });
  };

  render() {
    const { headers, data } = this.state.data;

    return (
      <MDBTable>
        <MDBTableHead>
          <tr>
            {headers.map(header => (
              <th key={header} onClick={() => this.sortData(header)}>
                {header}
                {this.state.sortedColumn === header && (this.state.sortDirection === 'asc' ? ' 🔼' : ' 🔽')}
              </th>
            ))}
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map(header => (
                <td key={header}>
                  <MDBInput
                    type="text"
                    value={row[header]}
                    onChange={(e) => this.handleEdit(rowIndex, header, e.target.value)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </MDBTableBody>
      </MDBTable>
    );
  }
}